import React from "react";
import { BRAND } from "../lib/api";

// Il logo completo verticale è riservato alle schermate ampie di accesso.
// Negli header e nelle sidebar il simbolo mantiene leggibilità e proporzioni corrette.
export function Logo({ variant = "light", showProduct = true, showImage = true, size = "md", className = "" }) {
  const full = size === "lg" && showImage && showProduct;
  const markHeight = size === "sm" ? "h-9" : "h-12";
  const titleColor = variant === "dark" ? "text-white" : "text-navy";
  const productColor = variant === "dark" ? "text-gold-bright" : "text-gold";
  const subColor = variant === "dark" ? "text-gold-bright/80" : "text-gold";

  if (full) {
    return (
      <div
        className={`flex flex-col items-center text-center ${className}`}
        data-testid="brand-logo"
        aria-label="DF HACCP — Gestione Digitale"
      >
        <img
          src={BRAND.symbol}
          alt=""
          aria-hidden="true"
          className="h-28 sm:h-32 w-auto object-contain drop-shadow-[0_12px_20px_rgba(10,31,68,0.16)]"
        />
        <div className="mt-3 font-heading text-4xl sm:text-[2.6rem] font-bold leading-none tracking-[-0.025em] text-navy">
          DF <span className="text-gold">HACCP</span>
        </div>
        <div className="mt-2.5 font-body text-[10px] sm:text-[11px] font-medium uppercase tracking-[0.16em] sm:tracking-[0.24em] text-slate-600">
          Controllo <span className="text-gold-bright" aria-hidden="true">•</span> Sicurezza <span className="text-gold-bright" aria-hidden="true">•</span> Conformità
        </div>
        <div className="mt-3 h-0.5 w-16 rounded-full bg-[#14C38E]" aria-hidden="true" />
        <div className="mt-2.5 font-heading text-sm sm:text-base text-slate-500">
          by Dottor Dario Feliciano
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      {showImage && <img src={BRAND.symbol} alt="" aria-hidden="true" className={`${markHeight} w-auto shrink-0 object-contain`} />}
      {showProduct && (
        <div className="leading-none min-w-0">
          <div className={`font-body font-bold tracking-[0.08em] ${titleColor} text-sm md:text-base whitespace-nowrap`}>DF <span className={productColor}>HACCP</span></div>
          <div className={`font-body text-[8px] md:text-[9px] uppercase tracking-[0.18em] ${subColor} mt-1 whitespace-nowrap`}>Gestione digitale</div>
        </div>
      )}
    </div>
  );
}

export default Logo;
